import React from 'react'
import { Section } from "../../ui"
import LogoPNG from '../../../assets/images/logo.png'
import DarkArrowSVG from '../../../assets/images/dark_arrow.svg'
import { howItWorksItems } from "../../../mock/howItWorks"

import './welcomeToHashrate.scss'

const openLink = (e) => {
    e.preventDefault();
    window.open("https://discord.gg/7ycuZFGz", '_blank');
}

const WelcomeToHashrateSection = () => {
  

    return (
        <Section>
            <div className="welcomeToHashrate-wrapper">
                <div className="title_container">
                    <img className="logo" src={LogoPNG} />
                    <h3 className="title_container-title">Welcome to</h3>
                    <h3 className="title_container-title title_container-gradient">Hashrate Studios</h3>
                    <p className="title_container-description">We are a Web3 filmmaking collective to finance and produce the next generation of feature films, tv series, and shorts</p>
                </div>

                <div className="splitter">
                    <button onClick={openLink} className="glow-on-hover">JOIN HERE</button>
                    {/* <img src={DarkArrowSVG} /> */}
                    <div />
                </div>

                <h4 className="list-description" id="how_it_works">At hashrate Studios, we make movies and share the royalties with you</h4>
                <h5 className="list-title">HERE IS HOW IT WORKS</h5>

                <ul className="list-wrapper">
                    {
                        howItWorksItems.map(({ description }, i) => (
                            <li key={i} className="outer_container">
                                <div className="inner_container">
                                    <p className="numbering">{`0${i + 1}`}</p>
                                    <p className="text">{description}</p>
                                </div>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </Section>
    )
}

export default WelcomeToHashrateSection
